import { useEffect, useState } from 'react';
import useDebouncedValue from '../../hooks/useDebouncedValue';
import SimpleInput from '../common/SimpleInput/SimpleInput';
import PropTypes from 'prop-types';
import styles from './Filters.module.scss';
import cn from 'classnames';
import { InfoTitle } from '../common/InfoTooltip';

export function TextFilter(props) {
  const { name, onChange, disabled, info, canEdit = true } = props;

  const [value, setValue] = useState(props.value);
  const debouncedValue = useDebouncedValue(value, 500);

  useEffect(() => {
    if (onChange) {
      onChange(debouncedValue.trim());
    }
  }, [debouncedValue]); // eslint-disable-line

  return (
    <div className={cn(styles.filter, styles.textFilter, disabled ? styles.disabled : '')}>
      <label>
        <span className={styles.title}>{name}</span>
        <InfoTitle content={info} disabled={!info}>
          <div>
            <SimpleInput
              value={value}
              onChange={(event) => (canEdit ? setValue(event.target.value) : event.target.blur())}
              disabled={disabled}
              onFocus={(event) => (canEdit ? null : event.target.blur())}
              placeholder={props.placeholder}
            />
          </div>
        </InfoTitle>
      </label>
    </div>
  );
}

TextFilter.defaultProps = {
  disabled: false,
  canEdit: true,
};

TextFilter.propTypes = {
  name: PropTypes.string.isRequired,
  info: PropTypes.string,
  value: PropTypes.string.isRequired,
  canEdit: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
};
